import { render, staticRenderFns } from "./ClientPhysicalEdit.vue?vue&type=template&id=1dbce944&scoped=true&"
import script from "./ClientPhysicalEdit.vue?vue&type=script&lang=js&"
export * from "./ClientPhysicalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbce944",
  null
  
)

export default component.exports